import { type Account } from '@pkg/graphql/codegen/graphql';
import { type SupportedWalletType } from '@pkg/types';

export const MAX_INITIAL_CONNECTED_WALLETS = 3;

export function getTypeFromAccount(accountAddress: Account['address']): SupportedWalletType {
    const [chain, _address] = accountAddress?.split('.') || [];

    switch (chain) {
        case 'aptos':
            return 'petra';
        case 'polygon':
            // TODO: We need to find a way to get the wallet connection type from the account.
            return 'walletConnect';
        case 'ethereum':
        default:
            return 'metaMask';
    }
}
